import { FdlFieldDefinitions } from '@treasury/FDL/record';
import { BeneficiaryDto } from '@treasury/domain/shared/types/beneficiary.dto';
import { string } from '@treasury/FDL';

export const BeneficiaryFieldDefinitions: FdlFieldDefinitions<BeneficiaryDto> = {
    accountNumber: string.with.label('Account Number').thatIs.readOnly(),
    name: string.with.label('Name').thatIs.readOnly(),
    notes: string.with.label('Notes').thatIs.readOnly(),
};
